import core from "@/helpers/client";
const authorizeProvider = {
  async getAuthorizeAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/authorizes?no-cache=1`
    );
    return result;
  },
  async getMenuItems(accessToken) {
      try {
          const result = await core.fetch(
              `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/authorizes?access_token=${accessToken}`

          );
          return result;
      } catch (err) {
          return err
      }
  }
}

export default authorizeProvider
